import { useLocation } from "react-router-dom";
import { useIsTrainerDashboard } from "@/hooks/useIsTrainerDashboard";

/**
 * Trainers (Lernbegleiter) enter the course without progress tracking, so the
 * course tree should not show progress rings / status circles for them. True
 * on the trainer dashboard sidebar and the trainer-preview course view.
 */
export const useHideCourseProgress = () => {
  const { pathname } = useLocation();
  const isTrainerDashboard = useIsTrainerDashboard();
  return pathname.includes("/trainer-preview") || isTrainerDashboard;
};
